import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DefaultActionFactory, DefaultActionFactoryToken } from "@core/redux/redux.module";
import { LocalStoreService, LocaleService, LocaleServiceToken } from "../../../core/index";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { DatePipe } from "@angular/common";
import * as _ from "lodash";
import { LocalDate } from "js-joda";
import { ResourceService, ResourceServiceToken } from "@feature_core/resource/resource.module";
import {
  SessionHandlerService,
  SessionHandlerServiceToken,
  SessionManagerService,
  SessionManagerServiceToken
} from "@feature_core/session/session.module";
import { environment } from "environments/environment";

@Component({
  templateUrl: "./login.component.html"
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {

  private _destroy$: Subject<boolean> = new Subject<boolean>();
  private datePipe: DatePipe;
  private actionFactory: DefaultActionFactory;
  public loginFormGroup: FormGroup;
  public loginError: any = false;
  public errMsg = "mkb.card3dsecure.page.login.general.error";
  public maxBirthDate: Date;
  public minBirthDate: Date;
  public pageDescription: string;
  private localeService: LocaleService;
  private _captchaResponse: string;
  public recaptchaEnabled: boolean = environment.recaptchaEnabled === "true";

  // @ViewChild("captchaTarget") targetRef: ElementRef;

  CARDHOLDER_MAX_AGE = 100;
  CARDHOLDER_MIN_AGE = 14;

  constructor(
    protected router: Router,
    private formBuilder: FormBuilder,
    @Inject(DatePipe) datePipe: DatePipe,
    @Inject(DefaultActionFactoryToken)
      defaultActionFactory: DefaultActionFactory,
    @Inject (LocaleServiceToken) localeService: LocaleService,
    @Inject(ResourceServiceToken) resourceService: ResourceService,
    @Inject(SessionHandlerServiceToken) protected _sessionHandler: SessionHandlerService,
    @Inject(SessionManagerServiceToken) protected _sessionManager: SessionManagerService
  ) {
    this.actionFactory = defaultActionFactory;
    this.loginFormGroup = this.formBuilder.group({
      cardLastNumber: ["", [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      cardName: ["", [Validators.required]],
      birthDate: ["", [Validators.required]]
    });
    if (this.recaptchaEnabled) {
      this.loginFormGroup.addControl('recaptchaReactive', this.formBuilder.control(null, Validators.required));
    }
    this._sessionManager.resetSession(-1);
    const nowTS = new Date().getTime();
    // The multiplication is only for easier readability:
    // Always code as if the guy who ends up maintaining your code will be a violent psychopath who knows where you live. Code for readability.
    this.maxBirthDate = new Date(nowTS - 1000 * 24 * 3600 * 365 * this.CARDHOLDER_MIN_AGE);
    this.minBirthDate = new Date(nowTS - 1000 * 24 * 3600 * 365 * this.CARDHOLDER_MAX_AGE);
    this.datePipe = datePipe;
    this.localeService = localeService;
    this.pageDescription = resourceService.resolve("mkb.card3dsecure.page.login.page.description");
  }

  ngOnInit(): void {
    this.loginError = false;
    LocalStoreService.clear();
    LocalStoreService.clearSessionTime();
    this._sessionHandler.clearSession();
  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.unsubscribe();
  }

  ngAfterViewInit () {
    setTimeout( () => {
      const iframe = document.getElementsByTagName("iframe")[0];
      if (iframe) {
        const src = iframe.getAttribute("src");
        const srcStr = src.split("&hl=");
        const nSrc = srcStr[0] + "&hl=" + this.localeService.getLocale() + srcStr[1].substr(2);
        iframe.setAttribute("src", nSrc);
      }
    });
  }

  public login() {
    this.loginError = false;
    const dateOfBirth = this.loginFormGroup.get("birthDate").value;
    if (this.loginFormGroup.valid && (this.recaptchaEnabled ? this._captchaResponse : true)) {
      this.actionFactory.login({
        cardNumber: this.loginFormGroup.get("cardLastNumber").value,
        cardCustomerName: this.loginFormGroup.get("cardName").value,
        dateOfBirth: LocalDate.parse(_.isString(dateOfBirth) ? dateOfBirth : this.datePipe.transform(dateOfBirth, "yyyy-MM-dd")),
        captchaResponse: this._captchaResponse
      }).pipe(
        takeUntil(this._destroy$)
      ).subscribe( resp => {
        if (resp.cardPhoneNumber && resp.cardPhoneNumber.length) {
          this.loginError = false;
          this.actionFactory.changeState({
            cardLastNumber: this.loginFormGroup.get("cardLastNumber").value,
            ownerName: this.loginFormGroup.get("cardName").value,
            cardPhoneNumber: resp.cardPhoneNumber
          }).pipe(
            takeUntil(this._destroy$)
          ).subscribe( state => {
            LocalStoreService.store( state );
          });
          this.router.navigate(["mkb3ds", "sign"]);
        } else {
          this.errMsg = "mkb.card3dsecure.page.login.nophonenr.error";
          this.loginError = "phone";
        }
      }, error => {
        if (error.cardId && error.cardStaticPassword && error.staticPasswordStatus && !error.cardPhoneNumber) {
          this.errMsg = "mkb.card3dsecure.page.login.nophonenr.error";
          this.loginError = "phone";
        } else {
          this.errMsg = "mkb.card3dsecure.page.login.general.error";
          this.loginError = true;
        }
      });
    }

  }

  captchaResponse(captchaResponse: string) {
    this._captchaResponse = captchaResponse;
  }
}
